import {
  AccessoriesResponse,
  Category,
  ConfigurationData,
  FormSchema,
  LooseProductsResponse,
  Product,
  UserAssignmentRequest,
} from "../../types";
import api from "../axios";

export const getProductById = async (productId: string) => {
  try {
    const response = await api.get<Product>(
      `Selectors/Products/${productId}`
    );
    return {...response.data, quantity: 1};
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export interface ProductsResponse {
  products: Product[];
  total: number;
}


export interface GetProductsByCategoriesParams {
  categoryId: string;
  offset: number;
  limit: number;
  search: string;
}

export const getProductsByCategories = async (
  params: GetProductsByCategoriesParams
) => {
  try {
    const response = await api.get<ProductsResponse>(
      `Selectors/Products/byCategory/${params.categoryId}`,
      {
        params: {
          offset: params.offset,
          limit: params.limit,
          search: params.search,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getAccessoriesByCategories = async (
  params: GetProductsByCategoriesParams
) => {
  try {
    const response = await api.get<AccessoriesResponse>(
      `Selectors/Products/accessories/byCategory/${params.categoryId}`,
      {
        params: {
          offset: params.offset,
          limit: params.limit,
          search: params.search,
        },
      }
    );

    const products: LooseProductsResponse = {
      products: response.data.accessories,
      total: response.data.total,
    };

    return products;
  } catch (error) {
    console.error("Error fetching accessories:", error);
    throw error;
  }
};

export const getPreconfiguredByCategories = async (
  params: GetProductsByCategoriesParams
) => {
  try {
    const response = await api.get<LooseProductsResponse>(
      `Selectors/Products/preconfigured/byCategory/${params.categoryId}`,
      {
        params: {
          offset: params.offset,
          limit: params.limit,
          search: params.search,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching preconfigured:", error);
    throw error;
  }
};

interface CategoryResponse {
  categories: Category[];
}

export const getCategories = async () => {
  try {
    const response = await api.get<CategoryResponse>(
      "Selectors/Products/Categories"
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

interface QuestionsResponse {
  formConfig: FormSchema;
}

export const getQuestions = async (productId: string) => {
  try {
    const response = await api.get<QuestionsResponse>(
      `Configurators/Products/${productId}/questions`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching questions:", error);
    throw error;
  }
};

export const postState = async (
  productId: string,
  payload: UserAssignmentRequest
) => {
  try {
    const response = await api.post<ConfigurationData>(
      `Configurators/Products/${productId}/state`,
      payload,
      {withCredentials: true}
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching questions:", error);
    throw error;
  }
};
